//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import FactorGroupItemDrawer from "./modules/FactorGroupItemDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryProjectArchtList } from '@/api/api';
export default {
  name: "FactorGroupItemList",
  mixins: [JeecgListMixin],
  components: {
    FactorGroupItemDrawer: FactorGroupItemDrawer
  },
  data: function data() {
    return {
      pagePath: '/site/factor/group/item',
      pageTitle: '环境监测因子组指标',
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: "center",
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'groupId',
        colName: 'group_id',
        title: '因子组ID',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'factorId',
        colName: 'factor_id',
        title: '监测因子ID',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'sort',
        colName: 'sort',
        title: '排序号',
        align: "center",
        sorter: true
      }, {
        dataIndex: 'tenantId',
        colName: 'tenant_id',
        title: '租户ID',
        align: "center",
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: "center",
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {},
  computed: {},
  methods: {}
};